import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "../../utils/toast";

import { resetPassword } from "../../api/auth";
import AuthLayout from "../../components/UX/AuthLayout";
import Button from "../../components/UX/Button";
import PasswordInput from "../../components/UX/PasswordInput";

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 8) {
      toast.error("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }

    setLoading(true);
    try {
      await resetPassword(token, password);
      toast.success("Ton mot de passe a été mis à jour.");
      navigate("/login");
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          "Ce lien de réinitialisation est invalide ou a expiré."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div className="text-center mb-2">
        <h1 className="font-logo text-3xl md:text-4xl text-black mb-3">
          Définir ton mot de passe
        </h1>
        <p className="font-josefin text-secondaryText text-sm md:text-base">
          Saisis ton nouveau mot de passe ci-dessous.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <PasswordInput
          id="reset-password"
          placeholder="Nouveau mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
          required
        />
        <Button type="submit" disabled={loading}>
          {loading ? "Enregistrement…" : "Confirmer"}
        </Button>
      </form>
    </AuthLayout>
  );
}

export default ResetPassword;
